import { IonCard, IonCardContent, IonCardHeader, IonCardTitle } from '@ionic/react';
import { FC } from 'react';


const EmptyMyPlayActivityMessage: FC = () => (
  <div className="favorites-container__list__empty-state-container">
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>No recent activity to show (yet!)</IonCardTitle>

        <IonCardContent>
          You may not have any play in this timeframe or for this insight, try another. If you’ve
          played recently, your data may still be updating—check again soon.
        </IonCardContent>
      </IonCardHeader>
    </IonCard>
  </div>
);
export default EmptyMyPlayActivityMessage;
